const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const sendVerificationEmail = async (email: string, code: string, firstName: string) => {
  try {
    const response = await fetch(`${API_URL}/send-verification-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code, firstName }),
    });

    if (!response.ok) {
      throw new Error('Failed to send verification email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending verification email:', error);
    throw error;
  }
};







